<template>
	<div>
		<div class="downloadM" v-show='!isIos'>
			<div v-show='isAndroid' class="content">
				<img src="@/assets/download/yunPCmobile@2x.png" class="img1">
				<div class="text">
					你的手机就是电脑！躺着玩、坐着玩、趴着玩，想怎么玩就怎么玩，没电脑不再是你错过游戏活动的理由
				</div>
				<img src="@/assets/download/download_android_text.png" class="img2">
				<div @click='downLoad(1)'>
					<img src="@/assets/download/xzbtn@2x.png" class="img3">
				</div>
			</div>
			<div class="wx-guide" v-show="iswx">
				<img src="@/assets/download/wx-img.png" class="wx-img" alt="">
			</div>
			<p class="footer-txt">Copyright © 2023 厦门同力合创网络科技有限公司深圳分公司版权所有</p>
		</div>

		<div v-show='isIos' class="ios-content">
			<img src="@/assets/download/ios_download_ho.jpg">
			<div class="download1" @click='downLoad(2)'></div>
			<!-- <div class="download2" @click='downLoad(2)'></div> -->
		</div>

		<div class="bg-guanwang" v-if="iswx">
			<img src="@/assets/download/right.png" alt="">
		</div>
	</div>
</template>

<script>
import '@/utils/adaptive.js';
import '@/utils/utils.js';

window['adaptive'].desinWidth = 750
window['adaptive'].baseFont = 18
window['adaptive'].maxWidth = 750
window['adaptive'].init();
export default {
	name: 'downloadM',
	data() {
		return {
			isIos: false,
			isAndroid: false,
			iswx: false,
			meteor: []
		}
	},
	created() {
		let that = this
		let u = navigator.userAgent;
		if (that.$utils.getQueryString('game') == 1) {
			that.$utils.Burying({ act: 'gameManager', operating_system: 'web' });
		}
		if (u.indexOf('Android') > -1 || u.indexOf('Adr') > -1) {
			that.isAndroid = true;
			that.isIos = false;

			if (that.$utils.getQueryString('game') == 1) {
				console.info('Android')
				that.$utils.Burying({ act: 'gameManagerAndroid', operating_system: 'web' });
			}

		} else if (u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)) {
			that.isIos = true;
			that.isAndroid = false;
			if (that.$utils.getQueryString('game') == 1) {
				console.info('ios')
				that.$utils.Burying({ act: 'gameManagerIos', operating_system: 'web' });
			}
		}
	},
	mounted() {
		// let that = this;
		// var ua = window.navigator.userAgent.toLowerCase();
		// IOS的落地页下载按钮的监测代码
		// let meteor
		// (function(r,d,s,l){meteor=r.meteor=r.meteor||[];meteor.methods=["track","off","on"];meteor.factory=function(method){return function(){
		// var args=Array.prototype.slice.call(arguments);args.unshift(method);meteor.push(args);return meteor}};for(var i=0;i<meteor.methods.length;i++){
		// var key=meteor.methods[i];meteor[key]=meteor.factory(key)}meteor.load=function(){var js,fjs=d.getElementsByTagName(s)[0];js=d.createElement(s);
		// js.src="https://analytics.snssdk.com/meteor.js/v1/"+l+"/sdk";fjs.parentNode.insertBefore(js,fjs)};meteor.load();if(meteor.invoked){return}
		// meteor.invoked=true;meteor.track("pageview")})(window,document,"script","1692996468227086");
		// this.meteor = meteor

	},
	methods: {
		getQueryValue(queryName) {
			var query = decodeURI(window.location.hash.split("?")[1]);
			var vars = query.split("&");
			for (var i = 0; i < vars.length; i++) {
				var pair = vars[i].split("=");
				if (pair[0] == queryName) { return pair[1]; }
			}
			return null;
		},
		downLoad(num) {
			let that = this
			var ua = window.navigator.userAgent.toLowerCase();
			if (ua.match(/MicroMessenger/i) == 'micromessenger') {
				//是微信浏览器-
				that.iswx = true
			} else {
				if (num === 1) {
					const channel = this.$route.query.channel || "official";
					const downloadUrl = `https://dl.tlhcxm.top/Android/channel/package/kind_7/${channel}.apk`;
					window.location.href = downloadUrl
				} else {
					if (that.$utils.getQueryString('game') == 1) {
						that.$utils.Burying({ act: 'gameDownLoadIos', operating_system: 'web' });
					} else {
						that.$utils.Burying({ act: 'downLoadIos', operating_system: 'web' });
					}
					let url = 'https://apps.apple.com/cn/app/%E6%B5%B7%E9%B8%A5%E4%BA%91%E7%94%B5%E8%84%91/id1614987972';
					window.location.href = url
				}
			}
		},
	}
}
</script>

<style lang="less" scoped>
.bg-guanwang {
	position: fixed;
	top: 0px;
	left: 0px;
	width: 100%;
	height: 100%;
	background: rgba(0, 0, 0, 0.8);
	z-index: 99999;

	img {
		position: fixed;
		top: 5%;
		right: 5%;
		width: 200px;
		height: auto;
	}
}

.ios-content {
	width: 100vw;
	height: auto;
	position: relative;

	img {
		width: 100%;
	}

	.download1 {
		position: absolute;
		top: 6.9rem;
		left: 50%;
		margin-left: -1.5rem;
		width: 3rem;
		height: .8rem;
		border-radius: 1rem;
		opacity: 0;
		// background: red;
		z-index: 999;
	}

	.download2 {
		position: absolute;
		bottom: .32rem;
		left: 50%;
		margin-left: -3.5rem;
		width: 7rem;
		height: 0.93rem;
		border-radius: 1rem;
		opacity: 0;
		// background: red;
		z-index: 999;
	}

	//适配苹果平板
	@media screen and (min-width: 750px) {
		.download1 {
			position: absolute;
			top: 9.4rem;
			left: 50%;
			margin-left: -2.05rem;
			width: 4.1rem;
			height: 1.1rem;
			border-radius: 1rem;
			opacity: 0;
			// background: red;
			z-index: 999;
		}

		.download2 {
			position: absolute;
			bottom: .32rem;
			left: 50%;
			margin-left: -4.65rem;
			width: 9.3rem;
			height: 1.4rem;
			border-radius: 1rem;
			opacity: 0;
			// background: red;
			z-index: 999;
		}
	}
}

.downloadM {
	width: 100%;
	height: 100%;
	position: fixed;
	background: url(../assets/download/downloadBg2.jpg) repeat-x center;
	background-size: 100% 100%;
	animation: cloud_three 80s linear infinite;
	transform: translate3d(0, 0, 0);
	overflow: auto;

	@-webkit-keyframes cloud_three {
		0% {
			background-position: 0 0;
		}

		100% {
			background-position: 1200px 0;
		}
	}

	@-moz-keyframes cloud_three {
		0% {
			background-position: 0 0;
		}

		100% {
			background-position: 1200px 0;
		}
	}

	@keyframes cloud_three {
		0% {
			background-position: 0 0;
		}

		100% {
			background-position: 1200px 0;
		}
	}

	.content {
		position: absolute;
		top: 50%;
		transform: translateY(-50%);
		-webkit-transform: translateY(-50%);
	}

	.img1 {
		vertical-align: middle;
		width: 5rem;
		height: 46px;
		margin-top: 150px;
		margin: 0 auto;
		display: block;
	}

	.text {
		color: #fff;
		text-align: center;
		font-size: 0.32rem;
		line-height: 0.6rem;
		width: 70%;
		margin: 0.8rem auto 0;
		display: block;
	}

	.img2 {
		width: 7.5rem;
		margin-top: 1rem;
	}

	.img3 {
		cursor: pointer;
		width: 3.75rem;
		display: block;
		margin: 1rem auto 0;
	}

	.wx-guide {
		width: 100%;
		height: 100%;
		position: fixed;
		background-color: rgba(0, 0, 0, 0.8);

		.wx-img {
			width: 4.27rem;
			position: absolute;
			right: 0.25rem;
			top: 0.25rem;
		}
	}

	.footer-txt {
		color: rgb(107, 117, 140);
		font-size: 0.22rem;
		position: fixed;
		bottom: 0.4rem;
		width: 100%;
		text-align: center;
		margin: 0;
	}

	.bky-logo {
		width: 1.2rem;
		margin: 0 auto 0.35rem;
		display: block;
	}

	.ios-tips {
		display: flex;
		align-items: center;
		justify-content: center;
		margin-top: 0.2rem;

		img {
			width: 0.3rem;
		}

		a {
			color: #F9DD4A;
			text-decoration: none;
			font-size: 0.24rem;
		}
	}
}</style>
